/**
 * Copyright © Veeam Software Group GmbH.
 */

export const MAX_INTEGER_32 = 2147483647;

export const DEFAULT_PASSWORD = '\u2022'.repeat(6);
